var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from "react";
import { postLoginAPI } from "../../../resources/helper/login";
import { searchPermissionInRoles } from "../../../utils/authUtils";
import { getHeader } from "../../../resources/headers";
import { handleUnauthorized } from "../../../resources/fetchRequest";
import { showErrorToast } from "../../../fnx/showError";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
var safeParseJson = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var text, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, response.text()];
            case 1:
                text = _a.sent();
                if (!text)
                    return [2 /*return*/, null];
                return [2 /*return*/, JSON.parse(text)];
            case 2:
                e_1 = _a.sent();
                console.warn("safeParseJson: no se pudo parsear el cuerpo JSON", e_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var useActivatePolicy = function (params) {
    var policyId = params.policyId, quoteId = params.quoteId, callQuoteOne = params.callQuoteOne, setSeeToast = params.setSeeToast, t = params.t, onActivate = params.onActivate, _a = params.permissionName, permissionName = _a === void 0 ? "admin-activate-policy" : _a;
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState(""), password = _c[0], setPassword = _c[1];
    var _d = useState(false), loadingLogin = _d[0], setLoadingLogin = _d[1];
    var _e = useState(false), loadingUpdatePolicy = _e[0], setLoadingUpdatePolicy = _e[1];
    var _f = useState(false), loadingReprint = _f[0], setLoadingReprint = _f[1];
    var _g = useState(false), wasSuccessful = _g[0], setWasSuccessful = _g[1];
    var overallLoading = loadingLogin || loadingUpdatePolicy || loadingReprint;
    var updatePolicyStatus = function (policyIdLocal) { return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, requestBody, requestOptions, response, parsed_1, parsed, error_1, errorForToast;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = "".concat(process.env.REACT_APP_HOST_API, "/asg/Api/V1/Policy/").concat(policyIdLocal, "/status");
                    requestBody = {
                        data: { catalogStatus: "d3cc46c2-a953-404c-9da9-d12578abf957" },
                    };
                    requestOptions = {
                        method: "PATCH",
                        body: JSON.stringify(requestBody),
                        headers: getHeader(),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(apiUrl, requestOptions)];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    handleUnauthorized(response.status);
                    return [4 /*yield*/, safeParseJson(response)];
                case 3:
                    parsed_1 = _a.sent();
                    throw __assign({ status: response.status }, (parsed_1 && typeof parsed_1 === "object" ? parsed_1 : {}));
                case 4: return [4 /*yield*/, safeParseJson(response)];
                case 5:
                    parsed = _a.sent();
                    return [2 /*return*/, { success: true, data: parsed }];
                case 6:
                    error_1 = _a.sent();
                    errorForToast = {
                        errors: (error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) || [],
                        message: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            (t
                                ? t("error.activatePolicy")
                                : "Error al activar la póliza. Intente nuevamente."),
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [2 /*return*/, { success: false, error: error_1 }];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var reprintCertificates = function (quoteIdLocal) { return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, requestOptions, response, parsed, error_2, errorForToast;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = "".concat(process.env.REACT_APP_HOST_API, "/asg/Api/V1/Quote/").concat(quoteIdLocal, "/Reprint");
                    requestOptions = { method: "POST", headers: getHeader() };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(apiUrl, requestOptions)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, safeParseJson(response)];
                case 3:
                    parsed = _a.sent();
                    if (!response.ok) {
                        handleUnauthorized(response.status);
                        throw __assign({ status: response.status }, (parsed && typeof parsed === "object" ? parsed : {}));
                    }
                    return [2 /*return*/, { success: true, data: parsed }];
                case 4:
                    error_2 = _a.sent();
                    errorForToast = {
                        errors: (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) || [],
                        message: (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                            (t
                                ? t("error.reprintCertificates")
                                : "Error al reimprimir los certificados. Intente nuevamente."),
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [2 /*return*/, { success: false, error: error_2 }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var activatePolicy = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var loginResponse, policyUpdateResult, reprintResult, err_1, errorForToast, e_2, e_3, allSucceeded;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoadingLogin(true);
                    setLoadingUpdatePolicy(false);
                    setLoadingReprint(false);
                    setWasSuccessful(false);
                    loginResponse = null;
                    policyUpdateResult = null;
                    reprintResult = null;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, postLoginAPI({ userName: email, password: password })];
                case 2:
                    // Login
                    loginResponse = _b.sent();
                    if (!searchPermissionInRoles(loginResponse, permissionName)) {
                        showToastSuccessMessage("El usuario ingresado no cuenta con el permiso para activar la póliza", typeAlert.warning, setSeeToast);
                        onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                            email: email,
                            password: password,
                            response: loginResponse,
                            success: false,
                            step: "permission",
                        });
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    errorForToast = {
                        errors: ((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _a === void 0 ? void 0 : _a.errors) || (err_1 === null || err_1 === void 0 ? void 0 : err_1.errors) || [],
                        message: (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || "Error al autenticar. Verifique sus credenciales.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                        email: email,
                        password: password,
                        errorData: err_1,
                        success: false,
                        step: "login",
                    });
                    return [2 /*return*/, false];
                case 4:
                    setLoadingLogin(false);
                    return [7 /*endfinally*/];
                case 5:
                    _b.trys.push([5, 7, 8, 9]);
                    setLoadingUpdatePolicy(true);
                    return [4 /*yield*/, updatePolicyStatus(policyId)];
                case 6:
                    policyUpdateResult = _b.sent();
                    if (!policyUpdateResult.success) {
                        onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                            email: email,
                            password: password,
                            response: loginResponse,
                            policyUpdateResult: policyUpdateResult,
                            success: false,
                            step: "updatePolicy",
                        });
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 9];
                case 7:
                    e_2 = _b.sent();
                    onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                        email: email,
                        password: password,
                        response: loginResponse,
                        errorData: e_2,
                        success: false,
                        step: "updatePolicy-exception",
                    });
                    return [2 /*return*/, false];
                case 8:
                    setLoadingUpdatePolicy(false);
                    return [7 /*endfinally*/];
                case 9:
                    _b.trys.push([9, 11, 12, 13]);
                    setLoadingReprint(true);
                    return [4 /*yield*/, reprintCertificates(quoteId)];
                case 10:
                    reprintResult = _b.sent();
                    if (!reprintResult.success) {
                        onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                            email: email,
                            password: password,
                            response: loginResponse,
                            policyUpdateResult: policyUpdateResult,
                            reprintResult: reprintResult,
                            success: false,
                            step: "reprint",
                        });
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 13];
                case 11:
                    e_3 = _b.sent();
                    onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                        email: email,
                        password: password,
                        response: loginResponse,
                        policyUpdateResult: policyUpdateResult,
                        errorData: e_3,
                        success: false,
                        step: "reprint-exception",
                    });
                    return [2 /*return*/, false];
                case 12:
                    setLoadingReprint(false);
                    return [7 /*endfinally*/];
                case 13:
                    allSucceeded = (policyUpdateResult === null || policyUpdateResult === void 0 ? void 0 : policyUpdateResult.success) && (reprintResult === null || reprintResult === void 0 ? void 0 : reprintResult.success);
                    if (allSucceeded) {
                        try {
                            callQuoteOne === null || callQuoteOne === void 0 ? void 0 : callQuoteOne(quoteId);
                        }
                        catch (e) {
                            console.error("Error al refrescar la cotización:", e);
                        }
                    }
                    // Success toast
                    showToastSuccessMessage("La póliza ha sido activada y los certificados reimpresos exitosamente", typeAlert.success, setSeeToast);
                    onActivate === null || onActivate === void 0 ? void 0 : onActivate({
                        email: email,
                        password: password,
                        response: loginResponse,
                        policyUpdateResult: policyUpdateResult,
                        reprintResult: reprintResult,
                        success: true,
                        step: "completed",
                    });
                    // Clear credentials after success
                    setEmail("");
                    setPassword("");
                    setWasSuccessful(true);
                    return [2 /*return*/, true];
            }
        });
    }); }, [
        email,
        password,
        policyId,
        quoteId,
        permissionName,
        callQuoteOne,
        setSeeToast,
        t,
        onActivate,
    ]);
    var getLoadingText = useCallback(function () {
        if (loadingLogin)
            return "Autenticando usuario...";
        if (loadingUpdatePolicy)
            return "Activando póliza...";
        if (loadingReprint)
            return "Reimprimiendo certificados...";
        return "";
    }, [loadingLogin, loadingUpdatePolicy, loadingReprint, t]);
    return {
        email: email,
        setEmail: setEmail,
        password: password,
        setPassword: setPassword,
        loadingLogin: loadingLogin,
        loadingUpdatePolicy: loadingUpdatePolicy,
        loadingReprint: loadingReprint,
        overallLoading: overallLoading,
        activatePolicy: activatePolicy,
        getLoadingText: getLoadingText,
        wasSuccessful: wasSuccessful,
    };
};
